import nextCookie from 'next-cookies'
import SETTINGS from '@/src/settings'

// Locales reellement supportees (alignees sur les langues CS-Cart actives + le garde-fou
// de csCartProxy.ts). Une langue navigateur hors de cette liste retombe sur le defaut (fr)
// au lieu de router vers une page de locale non geree.
const SUPPORTED_LOCALES = ['fr', 'en']

const getLocaleFromCtx = (ctx): string => {
  const { locale } = nextCookie(ctx)

  const browserLang = ctx?.req?.headers['accept-language']
    ?.split(',')?.[0]
    ?.split('-')?.[0]
    ?.trim()
    ?.toLowerCase()
  const browserLocale =
    browserLang && SUPPORTED_LOCALES.includes(browserLang) ? browserLang : undefined

  return ctx.query?.locale || locale || browserLocale || SETTINGS.localeDefault
}

export default getLocaleFromCtx
